import "./RentalFleet.module.css";
import MainNavigation from "@/reusable_sections/Header";
import VehicleCategories from "./sections/VehicleCategories";
import AvailableRentalUnits from "./sections/AvailableRentalUnits";
import RentalTermsFaq from "./sections/RentalTermsFaq";
import GlobalFooter from "@/reusable_sections/Footer";
export default function RentalFleetPage() {
  return <div>
      <MainNavigation />
      <VehicleCategories />
      <AvailableRentalUnits />
      <RentalTermsFaq />
      <GlobalFooter />
    </div>;
}